import R from 'ramda';

export const maxPrice = ({ retailers }) =>
  parseFloat(
    R.max(
      ...R.map(
        (retailer) =>
          R.max(
            ...R.map(
              (item) =>
                R.compose(
                  R.replace(R.prop('currencySymbol', item), ''),
                  R.replace(',', '.'),
                  R.replace('₽', '')
                )(R.prop('price', item)),
              R.prop('retailersList', retailer)
            ),
            retailers
          ),
        retailers
      )
    )
  );

export const minPrice = ({ retailers }) =>
  parseFloat(
    R.min(
      ...R.map(
        (retailer) =>
          R.min(
            ...R.map(
              (item) =>
                R.compose(
                  R.replace(R.prop('currencySymbol', item), ''),
                  R.replace(',', '.'),
                  R.replace('₽', '')
                )(R.prop('price', item)),
              R.prop('retailersList', retailer)
            ),
            retailers
          ),
        retailers
      )
    )
  );

export const schema = ({
  sectionHeadings,
  productDetails,
  tracking,
  retailers,
  currentUrl,
}) => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  '@id': currentUrl,
  name: R.path(['productDetails', 'heading'], sectionHeadings),
  image: R.path(
    ['attributes', 'productImage'],
    R.mergeAll(R.prop('product', tracking))
  ),
  description: R.prop('description', productDetails),
  url: currentUrl,
  brand: {
    '@type': 'Brand',
    name: 'Max Factor',
    logo: 'https://www.maxfactor.com/assets/images/logo.svg',
  },
  offers: retailers
    ? {
        '@type': 'AggregateOffer',
        lowPrice: minPrice({ retailers }).toFixed(2),
        highPrice: maxPrice({ retailers }).toFixed(2),
        priceCurrency: R.prop('currencyCode', tracking),
      }
    : undefined,
});
